import { render, staticRenderFns } from "./requestPayout.vue?vue&type=template&id=4b351b6c"
import script from "./requestPayout.vue?vue&type=script&lang=js"
export * from "./requestPayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports